function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _defs, _path, _g, _path2, _use;
var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};
var SvgDefaultAvatar = function SvgDefaultAvatar(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '35px' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '35px' : _ref$height,
    originalSize = _ref.originalSize,
    top = _ref.top,
    bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 252.7"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default-avatar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250 252.7-6.9-28.6c-6.9-28.6-45.38-39.4-68.82-48.22s-21.76-23.25-21.76-57.73h-55c0 34.48 1.68 48.9-21.76 57.73S13.8 195.48 6.9 224.1L0 252.7z",
    fill: "#a8b9ca"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-1.1%",
    width: "102.3%",
    height: "102.3%",
    id: "default-avatar_svg__b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "default-avatar_svg__c",
    cx: 125,
    cy: 126.5,
    r: 125
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m250 252.7-6.9-28.6c-6.9-28.6-45.38-39.4-68.82-48.22s-21.76-23.25-21.76-57.73h-55c0 34.48 1.68 48.9-21.76 57.73S13.8 195.48 6.9 224.1L0 252.7z",
    fill: "#a8b9ca"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default-avatar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.25 19.43C99 19.43 76.37 40.7 76.37 67L82 87.16c0 13.43 10 75.48 43.27 75.48 29 0 43.28-62 43.28-75.48l5.6-20.2c-.02-26.25-21.9-47.53-48.9-47.53z",
    fill: "#8d9aab"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m172.4 83.65 1.22-11.45c0-26.16-22.5-47.38-48.63-47.52C98.86 24.82 76.37 46 76.37 72.2l1.22 11.45c-5.25-.53-10.33 2.34-8 12.82 1.52 6.84 7.8 10.47 10.42 9.9l.48 8.55c0 27.6 32.62 41.23 44.5 41.4 11.9-.18 44.5-13.82 44.5-41.4l.48-8.55c2.6.56 8.9-3.07 10.42-9.9 2.33-10.47-2.75-13.35-8-12.82z",
    fill: "#a8b9ca"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    filter: "url(#default-avatar_svg__b)",
    xlinkHref: "#default-avatar_svg__c"
  })));
};
export { SvgDefaultAvatar as ReactComponent };
export default "/_next/static/media/default-avatar.d3b49094.svg";